import { createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, openBlock as _openBlock } from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 20 20",
      },
      [
        _createElementVNode("path", {
          fill: "currentColor",
          "fill-rule": "evenodd",
          d: "M18.438 20c.859 0 1.562-.703 1.562-1.563V1.563C20 .704 19.297 0 18.437 0H1.563C.704 0 0 .703 0 1.563v16.875C0 19.297.703 20 1.563 20zM10.095 3.963c-3.907 0-7.078 2.498-7.078 5.581 0 1.995 1.327 3.744 3.314 4.73-.109.375-.694 2.404-.721 2.567 0 0-.014.122.061.163.075.048.17.014.17.014.217-.033 2.42-1.575 2.94-1.94l.048-.034c.409.054.83.088 1.26.088 3.907 0 7.079-2.498 7.079-5.58.006-3.091-3.166-5.59-7.073-5.59Zm-4.322 7.14c0 .211.184.388.408.388.225 0 .409-.17.402-.388V8.68h.64a.402.402 0 0 0 0-.803h-2.09a.402.402 0 0 0 0 .803h.64zm3.647.198c.041.115.17.184.34.184a.55.55 0 0 0 .26-.055c.108-.048.217-.19.095-.579l-.974-2.573a.61.61 0 0 0-.544-.401.61.61 0 0 0-.545.401l-.98 2.567c-.122.38-.02.524.095.578a.7.7 0 0 0 .26.055c.17 0 .299-.068.34-.177l.204-.531h1.245l.204.53Zm-.823-2.403.408 1.157H8.19l.409-1.157Zm2.178 2.539a.387.387 0 0 1-.395-.375V8.285c0-.224.184-.408.415-.408a.41.41 0 0 1 .415.408v2.396h.871c.218 0 .395.17.395.375a.387.387 0 0 1-.395.374h-1.306zm1.857-.36a.41.41 0 0 0 .408.408.4.4 0 0 0 .409-.388v-.892l.143-.143.96 1.266a.42.42 0 0 0 .326.163.4.4 0 0 0 .402-.354.4.4 0 0 0-.082-.3l-1.007-1.333.932-.933a.34.34 0 0 0 .088-.252.4.4 0 0 0-.122-.258.38.38 0 0 0-.279-.123.3.3 0 0 0-.225.089L13.45 9.163v-.878a.41.41 0 0 0-.409-.408.41.41 0 0 0-.408.408z",
          "clip-rule": "evenodd",
        }),
      ]
    )
  );
}
